import { msg } from '@lingui/core/macro';
import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { coordinateFields } from './common/coordinateFields';
import { areaUnitField } from './common/sharedFields';

export const siteLandUseMetadata = {
  displayName: msg({
    message: 'Site land use',
    context: 'Activity data schema name for site land use',
  }),
  fields: {
    ...coreFields,
    ...coordinateFields,
    has_csrd_negatively_affecting_activities: {
      displayName: msg({
        message: 'Has activities negatively affecting biodiversity',
        context: 'The display name for a field',
      }),
    },
    is_in_or_near_biodiversity_sensitive_area: {
      displayName: msg({
        message: 'Is in or near a biodiversity sensitive area',
        context: 'The display name for a field',
      }),
    },
    natura_2000_site_codes: {
      displayName: msg({
        message: 'Natura 2000 site codes',
        context: 'Codes identifying Natura 2000 protected sites',
      }),
    },
    natura_2000_site_names: {
      displayName: msg({
        message: 'Natura 2000 site names',
        context: 'Names of Natura 2000 protected sites',
      }),
    },
    quantity: {
      displayName: msg({
        message: 'Site area',
        context: 'The area of the site.',
      }),
      externalDescription: msg({
        message: 'The area of the site.',
        context: 'Site area',
      }),
    },
    site_identifier: {
      displayName: msg({
        message: 'Site identifier',
        context: 'Unique identifier for the site.',
      }),
      externalDescription: msg({
        message: 'Unique identifier for the site.',
        context: 'Site identifier',
      }),
    },
    unit: areaUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
